export const TestBadge = ({ className = "" }) => (
  <span
    data-testid="test-badge"
    className={`inline-flex items-center rounded-full border border-amber-400 bg-amber-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-amber-800 ${className}`}
  >
    Test
  </span>
);
